import { filterSpecBySkuModules, isSkuModuleEnabled } from '../../_shared/common/sku/skuEnabledModules';
import type { VmSpec } from './schema';

const MODULE_FIELD_STRIPS: Record<string, (spec: VmSpec) => VmSpec> = {
  systemSetting: (spec) => ({
    ...spec,
    runStrategy: undefined,
    systemDisk: undefined,
  }),
  service: (spec) => ({
    ...spec,
    resource: {
      ...spec.resource,
      network: {
        ...spec.resource.network,
        service: undefined,
      },
    },
  }),
  resource: (spec) => ({
    ...spec,
    resource: {
      ...spec.resource,
      memory: undefined,
      cpu: {
        physicalCards: undefined,
        physicalCores: undefined,
        logicalCores: undefined,
      },
      gpu: undefined,
      cpuPricing: undefined,
      memoryPricing: undefined,
      gpuPricing: undefined,
      network: {
        ...spec.resource.network,
        Bandwidth: undefined,
        bandwidthPricing: undefined,
      },
    },
  }),
  dataDisk: (spec) => ({ ...spec, dataDisks: undefined }),
  dns: (spec) => ({
    ...spec,
    resource: {
      ...spec.resource,
      network: {
        ...spec.resource.network,
        dnsConfig: undefined,
      },
    },
  }),
};

/** 按 SKU enabledModules 裁剪 spec，防止未选模块泄漏到 resourceConfigs / preset / apiBody */
export function filterVmSpecByEnabledModules(spec: VmSpec, enabledModules?: Record<string, boolean>, skuType?: 'fixed' | 'custom'): VmSpec {
  return filterSpecBySkuModules(spec, MODULE_FIELD_STRIPS, enabledModules, skuType);
}

export function isVmModuleEnabled(moduleKey: string, enabledModules?: Record<string, boolean>, skuType?: 'fixed' | 'custom'): boolean {
  return isSkuModuleEnabled(moduleKey, enabledModules, skuType);
}
